import React, { memo } from 'react'

import { CloseTagFilled, Icon } from '@cgtrader/triangle-ui/dist/src/ssr-index'

const MODELS = [
  { key: 'quad', label: 'Quad models', image: '/assets/three_d_studio/segment_tab/quad_models.webp' },
  { key: 'rigged', label: 'Rigged models', image: '/assets/three_d_studio/segment_tab/rigged_models.webp' },
]

function UnavailableModels() {
  return (
    <div className="segment-tab__unavailable">
      <p className="segment-tab__unavailable-title cgt-caption-semibold">Unavailable for</p>
      <ul className="segment-tab__unavailable-list">
        {MODELS.map(({ key, label, image }) => (
          <li key={key} className="segment-tab__unavailable-item">
            <div className="segment-tab__unavailable-card">
              <img
                className="segment-tab__unavailable-image"
                src={image}
                alt=""
                aria-hidden="true"
              />
              <Icon
                svgComponent={CloseTagFilled}
                className="segment-tab__unavailable-badge"
                aria-hidden="true"
              />
            </div>
            <span className="segment-tab__unavailable-label cgt-caption-semibold">{label}</span>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default memo(UnavailableModels)
